import { MenuItem } from "../../../../commons/ui/menu";
import { About } from "../../../../screens/Public/About";

export const routes: MenuItem[] = [
  {
    key: "publicAboutMain",
    basePath: "/",
    target: {
      component: About,
      path: "/",
    },
    enabled: true,
    icon: "List",
    text: "About",
    children: [],
    default: true,
  },
];
